import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { store } from './redux';
import { RockPaperScissors } from './views/RockPaperScissors';

const LayoutComponent = () => (
	<Provider store={store}>
		<Background />
		<RockPaperScissors />
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.RockPaperScissors)
	.setHudVisible(true)
	.build();

export default Layout;
